import { authenticationService } from '@/application/services/api-clients/login-service';
import { financialDataVerificator } from '@/application/api';

export class FinancialDataVerificatorClient {
  constructor() {
    this.BASE_URL = '/financial-data-verificator/v1.0';
  }

  async createIncome(data) {
    const response = await financialDataVerificator.post(
      `${this.BASE_URL}/income`,
      data,
      this.defaultAxiosRequestConfig()
    );
    return response.data;
  }

  async updateIncome(id, data) {
    const response = await financialDataVerificator.put(
      `${this.BASE_URL}/income/${id}`,
      data,
      this.defaultAxiosRequestConfig()
    );
    return response.data;
  }

  async calculateIncome(data) {
    const response = await financialDataVerificator.post(
      `${this.BASE_URL}/income/calculate`,
      data,
      this.defaultAxiosRequestConfig()
    );
    return response.data;
  }

  async calculateDebt(data) {
    const response = await financialDataVerificator.post(
      `${this.BASE_URL}/debt/calculate`,
      data,
      this.defaultAxiosRequestConfig()
    );
    return response.data;
  }

  defaultAxiosRequestConfig() {
    return {
      headers: authenticationService.authHeader()
    };
  }
}
